import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import { IProps } from './interfaces';

class Dropdown extends React.Component<IProps> {
  public render() {
    const { disabled, error, value, title, helper } = this.props;

    return (
      <FormControl fullWidth={true} margin="dense" error={Boolean(error)}>
        <TextField
          id="outlined-select"
          select={true}
          label={title}
          value={value}
          disabled={disabled}
          onChange={this.handleChange}
          helperText={helper}
          margin="normal"
          variant="outlined"
          fullWidth={true}
        >
          {this.getOptions().map((option: any) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }

  private readonly getOptions = () => {
    const { options } = this.props;

    if (typeof options === 'function') {
      return options(this.props);
    }
    if (Array.isArray(options)) {
      return options;
    }

    return [];
  };

  private readonly handleChange = (event: any) => {
    const { onChange } = this.props;

    onChange(event.target.value);
  };
}

export default Dropdown;
